import { defaultApiState } from '@/store/types/general.types';
import { AxiosError } from 'axios';
import {
  ModuleResponseDTO,
  ModuleState,
  PaginatedModules
} from './module.types';

export const moduleMutations = {
  GET_MODULES_SUCCESS(state: ModuleState, data: ModuleResponseDTO[]) {
    state.apiState.getModules = {
      ...defaultApiState,
      success: true
    };
    state.modules = data;
  },
  GET_MODULES_LOADING(state: ModuleState) {
    state.apiState.getModules = {
      ...defaultApiState,
      loading: true
    };
    state.modules = undefined;
  },
  GET_MODULES_ERROR(state: ModuleState, error: AxiosError) {
    state.apiState.getModules = {
      ...defaultApiState,
      error
    };
  },

  GET_PAGINATED_MODULES_LOADING(state: ModuleState) {
    state.apiState.getPaginatedModules = {
      ...defaultApiState,
      loading: true
    };
    state.paginatedModules = undefined;
  },
  GET_PAGINATED_MODULES_SUCCESS(state: ModuleState, data: PaginatedModules) {
    state.apiState.getPaginatedModules = {
      ...defaultApiState,
      success: true
    };
    state.paginatedModules = data;
  },
  GET_PAGINATED_MODULES_ERROR(state: ModuleState, error: AxiosError) {
    state.apiState.getPaginatedModules = {
      ...defaultApiState,
      error
    };
  },

  CREATE_MODULE_LOADING(state: ModuleState) {
    state.apiState.createModule = {
      ...defaultApiState,
      loading: true
    };
  },
  CREATE_MODULE_SUCCESS(state: ModuleState) {
    state.apiState.createModule = {
      ...defaultApiState,
      success: true
    };
  },
  CREATE_MODULE_ERROR(state: ModuleState, error: AxiosError) {
    state.apiState.createModule = {
      ...defaultApiState,
      error
    };
  },

  UPDATE_MODULE_LOADING(state: ModuleState) {
    state.apiState.updateModule = {
      ...defaultApiState,
      loading: true
    };
  },
  UPDATE_MODULE_SUCCESS(state: ModuleState) {
    state.apiState.updateModule = {
      ...defaultApiState,
      success: true
    };
  },
  UPDATE_MODULE_ERROR(state: ModuleState, error: AxiosError) {
    state.apiState.updateModule = {
      ...defaultApiState,
      error
    };
  }
};
